import {
  API_USER_PATIENT_PROFILE_WEEKLY_REPORT_ACTIVITIES,
  AppUserPatientProfileWeeklyReportActivity,
} from './models';
import { apiRtk } from 'utils/rtk-query';
import { DynamicService } from 'utils/service';

class Service extends DynamicService<AppUserPatientProfileWeeklyReportActivity> {

}

export const ServiceUserPatientProfileWeeklyReportActivities = new Service({
  mainField: 'id',
  getAll: API_USER_PATIENT_PROFILE_WEEKLY_REPORT_ACTIVITIES.GET_ALL_DYNAMIC,
  post: API_USER_PATIENT_PROFILE_WEEKLY_REPORT_ACTIVITIES.POST,
  patch: API_USER_PATIENT_PROFILE_WEEKLY_REPORT_ACTIVITIES.PATCH,
  delete: API_USER_PATIENT_PROFILE_WEEKLY_REPORT_ACTIVITIES.DELETE,
});

export const apiUserPatientProfileWeeklyReportActivities = apiRtk.injectEndpoints({
  endpoints: (builder) => ({}),
});